module.exports = __webpack_public_path__ + "img/2.511a6ca7.jpg";